__turbopack_context__.v({
  "description": "UEHwPa_description",
  "header": "UEHwPa_header",
  "title": "UEHwPa_title",
});
